import React, { useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { AddButton, Button } from '../util/buttons';
import CompanyUserItem from './CompanyUserItem';
import { useTranslation } from 'react-i18next';
import { Dropdown } from '../util';
import companyUsersService from '../services/company_user.service';
import { handleError } from '../store/features/alertSlice';
import { useDispatch } from 'react-redux';
export default function AddUserToCompany(_ref) {
  let {
    user,
    setUser,
    companies
  } = _ref;
  const {
    t
  } = useTranslation();
  const [selectedCompany, setSelectedCompany] = useState({});
  const dispatch = useDispatch();
  const removeCompanyFromUser = async index => {
    if (user.id && user.company_users[index].id) {
      const id = user.company_users[index].id;
      try {
        const companyUsers = user.company_users;
        const newCompanyUsers = companyUsers.filter(companyUser => companyUser.id !== id);
        await companyUsersService.delete(user.id, id);
        setUser({
          ...user,
          company_users: newCompanyUsers,
          company_users_attributes: newCompanyUsers
        });
      } catch (error) {
        dispatch(handleError(error));
      }
    } else {
      const newCompanyUsers = user.company_users;
      newCompanyUsers.splice(index, 1);
      setUser({
        ...user,
        company_users: newCompanyUsers,
        company_users_attributes: newCompanyUsers
      });
    }
  };
  const addCompanyToUser = company => {
    const companyUsers = user.company_users;
    companyUsers.push({
      company: {
        name: company.name,
        id: company.id
      },
      company_id: company.id
    });
    setUser({
      ...user,
      company_users: companyUsers,
      company_users_attributes: companyUsers
    });
  };
  const changeSelectedCompany = companyId => {
    const currentCompany = companies.find(company => company.id == companyId);
    setSelectedCompany(currentCompany || {});
  };
  const remainingCompaniesOptionsToAdd = companies.filter(company => user.company_users.every(cu => cu.company_id !== company.id)).map(company => ({
    key: company.id,
    value: company.id,
    text: company.name
  }));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: true,
    md: 3
  }, t('companies')), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(Dropdown, {
    options: remainingCompaniesOptionsToAdd,
    onChange: changeSelectedCompany
  })), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(AddButton, {
    variant: "link",
    disabled: !selectedCompany,
    onClick: () => {
      addCompanyToUser(selectedCompany);
      setSelectedCompany({});
    }
  }))), user.company_users.map((uc, index) => {
    return /*#__PURE__*/React.createElement(CompanyUserItem, {
      companyUser: uc,
      handleDelete: removeCompanyFromUser,
      key: index,
      index: index
    });
  }));
}